const whitelistedDomains = [
  'pitchinteractive.com',
  'savetheredwoods.org',
]

const whitelistedEmails = [
  'georgia.young@gmail.com',
  'jac.m.perkins@gmail.com',
  'emily.algire@gmail.com',
  'savetheredwoods@gmail.com',
]
function validateEmail(_email) {
  const email = _email.toLowerCase()
  if (email) {
    const domain = email.split('@')[1]
    if (whitelistedDomains.includes(domain)) {
      return true
    } else if (whitelistedEmails.includes(email)) {
      return true
    }
  }
  return false
}

exports.validateEmail = validateEmail
exports.checkUser = (auth) => {
  const currentUser = auth.currentUser
  if (currentUser) {
    const email = currentUser.email
    return validateEmail(email)
  }
  return false
}
